import React from 'react';

interface ArrowSvgProps {
  className?: string;
}

export const ArrowSvg: React.FC<ArrowSvgProps> = ({ className }) => {
  return (
    <svg 
      width="16" 
      height="12" 
      viewBox="0 0 16 12" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M8 4L8 -3.49691e-07L10 -4.37114e-07L16 6L10 12L8 12L8 8L-1.74845e-07 8L-3.01991e-07 4L8 4Z" 
        fill="currentColor" 
      />
    </svg>
  );
}; 